import React from 'react';

const CTA: React.FC = () => {
  return (
    <section className="cta" id="contacto">
      <div className="container">
        <div className="cta-content">
          <h2>¿Listo para transformar tu empresa con APOLOX?</h2>
          <p>Comienza gratis • Sin tarjeta de crédito</p>
          <a 
            href="https://wa.me/573123456789?text=¡Hola!%20Estoy%20interesado%20en%20APOLOX%20y%20me%20gustaría%20solicitar%20una%20demo%20gratuita.%20Necesito%20un%20sistema%20completo%20de%20gestión%20empresarial%20con%20facturación%20electrónica%20DIAN.%20¿Pueden%20ayudarme?" 
            className="btn-primary-large"
          >
            Solicitar Demo Gratuita
          </a>
          <div className="cta-note">#Transforma tu gestión empresarial</div>
        </div>
      </div>
    </section>
  );
};

export default CTA;